import React from 'react';
import styled from 'styled-components';

import Chevron from '../../assets/chevron';

const Wrapper = styled.span`
  display: inline-block;
  transform: rotate(-90deg);
`;

const RightChevron = () => (
  <Wrapper>
    <Chevron />
  </Wrapper>
);

export default RightChevron;
